/* eslint-disable no-case-declarations */
import {
  getBoolean,
  WGT_LIST,
  COMMAND_LIST,
  // SETTING_API_URL,
  MIN_INT32,
  MAX_INT32,
  MIN_DEC_PLACE,
  MAX_DEC_PLACE,
  STS,
  ANALOG_INPUT,
  DIGITAL_INPUT,
  DIGITAL_OUTPUT,
  TEMPERATURE,
  SOLLAE_MODEL,
  // SOLLAE_BASE_URL,
  BAUD_RATE,
  PARITY,
  cloneObject,
  DATA_BIT,
  STOP_BIT,
  isModbusGateway,
  MAX_INTERFRAME_GAP,
  MIN_INTERFRAME_GAP,
} from './utils';

const TYPE_INP = 0;
const TYPE_SEL = 1;
const TYPE_TXT = 2;
// const TYPE_RDB = 3;
const TYPE_CBB = 4;
const TYPE_BAR = 5;
const TYPE_WGT = 6;
const TYPE_TAB = 7;
const TYPE_BTN = 8;
const TYPE_CMD = 9;
// const TYPE_LNK = 10;
const TYPE_RAN = 11;
const TYPE_SPR = 12;
const TYPE_LST = 13;
const TYPE_SLV = 14;

const MAX_STRING_LEN = 32;
const MAX_UNIT_STR_LEN = 8;

export const FORMAT = {
  STRING: 0,
  INT: 1,
  FLOAT: 2,
};

const { CMD_OUTPUT_LOW, CMD_OUTPUT_HIGH, CMD_OUTPUT_TOGGLE, CMD_OUTPUT_PULSE } =
  COMMAND_LIST;

const {
  WGT_AI_CBAR,
  WGT_AI_CHART,
  WGT_AI_THERMO,
  WGT_AI_GAUGE,
  WGT_AI_TEXT,
  WGT_AI_DROPLET,
  WGT_AI_HBAR,
  WGT_AI_VBAR,
  WGT_AI_7SEG,
  WGT_DI_CHART,
  WGT_DI_DLED,
  WGT_DI_COUNTER,
  WGT_DO_PLED,
  WGT_DO_SCHL,
  WGT_DO_CHART,
} = WGT_LIST;

const COLOR_LIST = [
  '#a43434',
  '#df691b',
  '#ebb311',
  '#169804',
  '#2c80af',
  '#7914a9',
  '#171c86',
];

export const V2_COLOR_LIST = [
  '#c0392b',
  '#e67e22',
  '#f1c40f',
  '#16a085',
  '#2980b9',
  '#9b59b6',
  '#2c3e50',
];

const ICON_CAT_GENERAL = require('@/assets/img/icon_cat_general.png');
const ICON_CAT_DEVICE = require('@/assets/img/icon_cat_device.png');
const ICON_CAT_WIDGET = require('@/assets/img/icon_cat_widget.png');
const ICON_CAT_EVENT = require('@/assets/img/icon_cat_event.png');
const ICON_CAT_ACTION = require('@/assets/img/icon_cat_action.png');
const ICON_CAT_SCHEDULE = require('@/assets/img/icon_cat_schedule.png');
const ICON_CAT_SERIAL = require('@/assets/img/icon_cat_serial.png');
const ICON_CAT_MODBUS = require('@/assets/img/icon_cat_modbus.png');
const ICON_CAT_QUERY = require('@/assets/img/icon_cat_query.png');

const ICON_CMD_TOGGLE = require('@/assets/img/icon_toggle.png');
const ICON_CMD_ON = require('@/assets/img/icon_on.png');
const ICON_CMD_OFF = require('@/assets/img/icon_off.png');
const ICON_CMD_PULSE_HIGH = require('@/assets/img/icon_on_pulse.png');

export const LISTCOMMAND_NO = [
  {
    text: 'ON/OFF',
    hasPwm: false,
    type: CMD_OUTPUT_TOGGLE,
    icon: ICON_CMD_TOGGLE,
  },
  { text: 'ON', hasPwm: false, type: CMD_OUTPUT_HIGH, icon: ICON_CMD_ON },
  { text: 'OFF', hasPwm: false, type: CMD_OUTPUT_LOW, icon: ICON_CMD_OFF },
  {
    text: 'PULSE',
    hasPwm: true,
    type: CMD_OUTPUT_PULSE,
    icon: ICON_CMD_PULSE_HIGH,
  },
];

export const LISTCOMMAND_NC = [
  {
    text: 'ON/OFF',
    hasDelay: true,
    hasPwm: false,
    type: CMD_OUTPUT_TOGGLE,
    icon: ICON_CMD_TOGGLE,
  },
  {
    text: 'ON',
    hasDelay: true,
    hasPwm: false,
    type: CMD_OUTPUT_LOW,
    icon: ICON_CMD_ON,
  },
  {
    text: 'OFF',
    hasDelay: true,
    hasPwm: false,
    type: CMD_OUTPUT_HIGH,
    icon: ICON_CMD_OFF,
  },
  {
    text: 'PULSE',
    hasDelay: true,
    hasPwm: true,
    type: CMD_OUTPUT_PULSE,
    icon: ICON_CMD_PULSE_HIGH,
  },
];

export const EVENTLIST_AI = [
  { value: '>=', text: 'SETTING.str18' },
  { value: '<=', text: 'SETTING.str19' },
];
export const EVENTLIST_DI = [
  { value: '==1', text: 'SETTING.str22' },
  { value: '==0', text: 'SETTING.str21' },
  { value: '>=', text: 'SETTING.str39' },
  { value: '<=', text: 'SETTING.str65' },
];
export const EVENTLIST_DO = [
  { value: '==1', text: 'SETTING.str22' },
  { value: '==0', text: 'SETTING.str21' },
];

export const MENU_CODE = {
  DEMO: 'demo',
  ENAB: 'ui_display',
  AIMODE: 'ai_mode',
  PORTDESC: 'port_desc',
  WIDGET: 'ui_widget',
  UNIT: 'unit',
  COLOR: 'ui_color',
  DISPLAYMIN: 'display_min',
  DISPLAYMAX: 'display_max',
  PORTMIN: 'port_min',
  PORTMAX: 'port_max',
  EVENT: 'events',
  FORMAT: 'dec_place',
  SCHEDULE: 'schedules',
  SAFEMODE: 'safe_mode',
  RELAYMODE: 'relay_mode',
  BUTTONS: 'commands',
  COUNTTYPE: 'count_type',
  COUNTDIR: 'count_dir',
  COUNTDEF: 'count_def',
  VALIDTIME: 'valid_time',
  DEVDESC: 'dev_desc',
  DEVMACADDR: 'mac_addr',
  DEVMODEL: 'dev_model',
  /*
    DEVREGLOG: 'dev_trigger_registration',
    DEVCONNLOG: 'dev_trigger_connection',
    DEVSETTLOG: 'dev_trigger_setting',
    DEVEVTLOG: 'dev_trigger_event',
    DEVSCHLOG: 'dev_trigger_schedule',
    DEVWEBLOG: 'dev_trigger_web_control',
    GGLOG: 'google_sheet',
    SEPARATOR: 'separator',
  */
  DEV_NOTICE: 'dev_notice',
  ACTION_LIST: 'action_list',
  // Modbus Configuration
  MBUS_MODE: 'modbus_mode',
  MBUS_TIMEOUT: 'modbus_timeout',
  MBUS_IFGAP: 'modbus_interframe_gap',
  // Serial Configuration
  BAUD_RATE: 'serial_baudrate',
  PARITY: 'serial_parity',
  DATA_BIT: 'serial_data_bit',
  STOP_BIT: 'serial_stop_bit',
  // Slave Configuration
  MBUS_SLAVES: 'ports',
};

export const CATEGORY = [
  {
    id: 'cat_gen',
    label: 'SETTING.str36',
    list: [
      MENU_CODE.DEVDESC,
      MENU_CODE.DEVMACADDR,
      MENU_CODE.DEVMODEL,
      MENU_CODE.SEPARATOR,
      MENU_CODE.DEVREGLOG,
      MENU_CODE.DEVCONNLOG,
      MENU_CODE.DEVSETTLOG,
      MENU_CODE.DEVWEBLOG,
      MENU_CODE.DEVEVTLOG,
      MENU_CODE.DEVSCHLOG,
      MENU_CODE.GGLOG,
    ],
    icon: ICON_CAT_GENERAL,
  },
  {
    id: 'cat_dev',
    label: 'SETTING.str37',
    list: [
      MENU_CODE.AIMODE,
      MENU_CODE.PORTDESC,
      MENU_CODE.PORTMIN,
      MENU_CODE.SAFEMODE,
      MENU_CODE.VALIDTIME,
      MENU_CODE.COUNTTYPE,
      MENU_CODE.COUNTDIR,
      MENU_CODE.COUNTDEF,
      MENU_CODE.DEV_NOTICE,
    ],
    icon: ICON_CAT_DEVICE,
  },
  {
    id: 'cat_wgt',
    label: 'SETTING.str03',
    list: [
      MENU_CODE.ENAB,
      MENU_CODE.WIDGET,
      MENU_CODE.UNIT,
      MENU_CODE.COLOR,
      MENU_CODE.DISPLAYMIN,
      MENU_CODE.FORMAT,
      MENU_CODE.COLOR,
      MENU_CODE.BUTTONS,
      MENU_CODE.RELAYMODE,
      MENU_CODE.DEMO,
    ],
    icon: ICON_CAT_WIDGET,
  },
  {
    id: 'cat_evt',
    label: 'SETTING.str09',
    list: [MENU_CODE.EVENT],
    icon: ICON_CAT_EVENT,
  },
  {
    id: 'cat_act',
    label: 'SETTING.str99',
    list: [MENU_CODE.ACTION_LIST],
    icon: ICON_CAT_ACTION,
  },
  {
    id: 'cat_sch',
    label: 'SETTING.str10',
    list: [MENU_CODE.SCHEDULE],
    icon: ICON_CAT_SCHEDULE,
    // selected_icon: ICON_CAT_SCHEDULE
  },
  {
    id: 'cat_ser',
    label: 'SETTING.serial',
    display: 'SETTING.str37',
    list: [
      MENU_CODE.BAUD_RATE,
      MENU_CODE.PARITY,
      MENU_CODE.DATA_BIT,
      MENU_CODE.STOP_BIT,
    ],
    icon: ICON_CAT_SERIAL,
  },
  {
    id: 'cat_mdb',
    label: 'SETTING.mbus',
    display: 'SETTING.str37',
    list: [MENU_CODE.MBUS_MODE, MENU_CODE.MBUS_TIMEOUT, MENU_CODE.MBUS_IFGAP],
    icon: ICON_CAT_MODBUS,
  },
  {
    id: 'cat_qry',
    label: 'SETTING.queries',
    list: [MENU_CODE.MBUS_SLAVES],
    icon: ICON_CAT_QUERY,
  },
];

const ANALOG_INPUT_TEMPLATE = [
  {
    name: 'SETTING.str02',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str15', value: 1 },
      { label: 'SETTING.str16', value: 0 },
    ],
    code: MENU_CODE.ENAB,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str04',
    type: TYPE_INP,
    code: MENU_CODE.PORTDESC,
    max_len: MAX_STRING_LEN,
    form: FORMAT.STRING,
  },
  {
    name: 'SETTING.str41',
    type: TYPE_TXT,
    list: [
      { label: '0 ~ 5V', value: 0 },
      { label: '4 ~ 20mA', value: 1 },
      { label: '0 ~ 20mA', value: 2 },
    ],
    code: MENU_CODE.AIMODE,
  },
  {
    name: 'SETTING.str86',
    type: TYPE_RAN,
    code: MENU_CODE.PORTMIN,
    ref: MENU_CODE.PORTMAX,
    form: FORMAT.FLOAT,
    highlight: false,
  },
  {
    code: MENU_CODE.PORTMAX,
  },
  {
    name: 'SETTING.str03',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str23', value: WGT_AI_TEXT },
      { label: 'SETTING.str24', value: WGT_AI_GAUGE },
      { label: 'SETTING.str26', value: WGT_AI_THERMO },
      { label: 'SETTING.str27', value: WGT_AI_DROPLET },
      { label: 'SETTING.str28', value: WGT_AI_HBAR },
      { label: 'SETTING.str29', value: WGT_AI_VBAR },
      { label: 'SETTING.str30', value: WGT_AI_CBAR },
      { label: 'SETTING.str25', value: WGT_AI_CHART },
    ],
    code: MENU_CODE.WIDGET,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str05',
    type: TYPE_CBB,
    code: MENU_CODE.UNIT,
    max_len: MAX_UNIT_STR_LEN,
    form: FORMAT.STRING,
    list: [
      { label: 'Ω', value: 'Ω' },
      { label: '%', value: '%' },
      { label: '‰', value: '‰' },
      { label: '°C', value: '°C' },
      { label: '°F', value: '°F' },
    ],
  },
  {
    name: 'SETTING.str06',
    type: TYPE_BAR,
    list: COLOR_LIST,
    code: MENU_CODE.COLOR,
    form: FORMAT.STRING,
  },
  {
    name: 'SETTING.str87',
    type: TYPE_RAN,
    code: MENU_CODE.DISPLAYMIN,
    ref: MENU_CODE.DISPLAYMAX,
    form: FORMAT.FLOAT,
    highlight: false,
  },
  {
    code: MENU_CODE.DISPLAYMAX,
  },
  {
    name: 'SETTING.str44',
    type: TYPE_INP,
    code: MENU_CODE.FORMAT,
    form: FORMAT.INT,
    min: MIN_DEC_PLACE,
    max: MAX_DEC_PLACE,
  },
  {
    name: 'SETTING.str09',
    type: TYPE_BTN,
    code: MENU_CODE.EVENT,
    custom_class: 'single-row-item',
  },
  {
    name: 'SETTING.str52',
    type: TYPE_WGT,
    code: MENU_CODE.DEMO,
    ref: MENU_CODE.ENAB,
    custom_class: 'demo-item',
  },
  /* {
        name: 'SETTING.str10',
        type: TYPE_BTN,
        code: MENU_CODE.TRIGGER,
        custom_class: 'single-row-item'
    }, */
];

const DIGITAL_INPUT_TEMPLATE = [
  {
    name: 'SETTING.str02',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str15', value: 1 },
      { label: 'SETTING.str16', value: 0 },
    ],
    code: MENU_CODE.ENAB,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str04',
    type: TYPE_INP,
    code: MENU_CODE.PORTDESC,
    max_len: MAX_STRING_LEN,
    form: FORMAT.STRING,
  },
  {
    name: 'SETTING.str58',
    type: TYPE_INP,
    code: MENU_CODE.VALIDTIME,
    form: FORMAT.INT,
    odev: true,
    min: 100,
    max: 30000,
  },
  {
    name: 'SETTING.str53',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str54', value: 1 },
      { label: 'SETTING.str55', value: 2 },
      { label: 'SETTING.str56', value: 3 },
    ],
    code: MENU_CODE.COUNTTYPE,
    odev: true,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str57',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str81', value: 0 },
      { label: 'SETTING.str82', value: 1 },
    ],
    code: MENU_CODE.COUNTDIR,
    odev: true,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str88',
    type: TYPE_INP,
    code: MENU_CODE.COUNTDEF,
    form: FORMAT.INT,
    odev: true,
    min: MIN_INT32,
    max: MAX_INT32,
  },
  {
    name: 'SETTING.str94',
    type: TYPE_SPR,
    code: MENU_CODE.DEV_NOTICE,
    custom_class: 'notice-row-item',
  },
  {
    name: 'SETTING.str03',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str31', value: WGT_DI_DLED },
      // { label: 'SETTING.str25', value: WGT_DI_CHART },
      { label: 'SETTING.str62', value: WGT_DI_COUNTER },
      { label: 'SETTING.str25', value: WGT_DI_CHART },
    ],
    code: MENU_CODE.WIDGET,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str06',
    type: TYPE_BAR,
    list: V2_COLOR_LIST,
    code: MENU_CODE.COLOR,
    form: FORMAT.STRING,
  },
  {
    type: TYPE_BTN,
    code: MENU_CODE.EVENT,
    custom_class: 'single-row-item',
  },
  {
    name: 'SETTING.str52',
    type: TYPE_WGT,
    code: MENU_CODE.DEMO,
    ref: MENU_CODE.ENAB,
    custom_class: 'demo-item',
  },
  /* {
        name: 'SETTING.str10',
        type: TYPE_BTN,
        code: MENU_CODE.TRIGGER,
        custom_class: 'single-row-item'
    } */
];

const DIGITAL_OUTPUT_TEMPLATE = [
  {
    name: 'SETTING.str02',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str15', value: 1 },
      { label: 'SETTING.str16', value: 0 },
    ],
    code: MENU_CODE.ENAB,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str04',
    type: TYPE_INP,
    code: MENU_CODE.PORTDESC,
    max_len: MAX_STRING_LEN,
    form: FORMAT.STRING,
  },
  {
    name: 'SETTING.str59',
    type: TYPE_TXT,
    list: [
      { label: 'SETTING.str61', value: 0 },
      { label: 'SETTING.str60', value: 1 },
    ],
    code: MENU_CODE.SAFEMODE,
  },
  /* Temporarily disabled
  {
    name: 'SETTING.str83',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str84', value: 0 },
      { label: 'SETTING.str85', value: 1 },
    ],
    code: MENU_CODE.RELAYMODE,
    form: FORMAT.INT,
  },
  */
  {
    name: 'SETTING.str03',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str31', value: WGT_DO_PLED },
      { label: 'SETTING.str89', value: WGT_DO_SCHL },
      { label: 'SETTING.str25', value: WGT_DO_CHART },
    ],
    code: MENU_CODE.WIDGET,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str06',
    type: TYPE_BAR,
    list: COLOR_LIST,
    code: MENU_CODE.COLOR,
    form: FORMAT.STRING,
  },
  {
    name: 'SETTING.str67',
    custom_class: 'button-row-item',
    type: TYPE_CMD,
    code: MENU_CODE.BUTTONS,
    ref: MENU_CODE.RELAYMODE,
  },
  {
    type: TYPE_BTN,
    code: MENU_CODE.EVENT,
    custom_class: 'single-row-item',
  },
  {
    type: TYPE_BTN,
    code: MENU_CODE.SCHEDULE,
    custom_class: 'single-row-item',
    ref: MENU_CODE.RELAYMODE,
  },
  {
    name: 'SETTING.str52',
    type: TYPE_WGT,
    code: MENU_CODE.DEMO,
    ref: MENU_CODE.ENAB,
    custom_class: 'demo-item',
  },
  {
    type: TYPE_LST,
    code: MENU_CODE.ACTION_LIST,
    custom_class: 'single-row-item action-row-item',
  },
];

const ANALOG_THERMO_TEMPLATE = [
  {
    name: 'SETTING.str02',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str15', value: 1 },
      { label: 'SETTING.str16', value: 0 },
    ],
    code: MENU_CODE.ENAB,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str04',
    type: TYPE_INP,
    code: MENU_CODE.PORTDESC,
    max_len: MAX_STRING_LEN,
    form: FORMAT.STRING,
  },
  {
    name: 'SETTING.str03',
    type: TYPE_SEL,
    list: [
      { label: 'SETTING.str23', value: WGT_AI_TEXT },
      { label: 'SETTING.str24', value: WGT_AI_GAUGE },
      { label: 'SETTING.str26', value: WGT_AI_THERMO },
      { label: 'SETTING.str07', value: WGT_AI_7SEG },
      { label: 'SETTING.str28', value: WGT_AI_HBAR },
      { label: 'SETTING.str29', value: WGT_AI_VBAR },
      { label: 'SETTING.str30', value: WGT_AI_CBAR },
      { label: 'SETTING.str25', value: WGT_AI_CHART },
    ],
    code: MENU_CODE.WIDGET,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.str103',
    type: TYPE_TXT,
    code: MENU_CODE.UNIT,
    list: [
      { label: '°C', value: '°C' },
      { label: '°F', value: '°F' },
    ],
  },
  {
    name: 'SETTING.str06',
    type: TYPE_BAR,
    list: COLOR_LIST,
    code: MENU_CODE.COLOR,
    form: FORMAT.STRING,
  },
  {
    name: 'SETTING.str87',
    type: TYPE_RAN,
    code: MENU_CODE.DISPLAYMIN,
    ref: MENU_CODE.DISPLAYMAX,
    form: FORMAT.FLOAT,
    highlight: false,
  },
  {
    code: MENU_CODE.DISPLAYMAX,
  },
  {
    name: 'SETTING.str09',
    type: TYPE_BTN,
    code: MENU_CODE.EVENT,
    custom_class: 'single-row-item',
  },
  {
    name: 'SETTING.str52',
    type: TYPE_WGT,
    code: MENU_CODE.DEMO,
    ref: MENU_CODE.ENAB,
    custom_class: 'demo-item',
  },
];

const GENERAL_INFO_TAB = [
  {
    type: TYPE_TAB,
    name: 'SETTING.str51',
    tab: 'deviceinfo',
  },
  /*,
    {
        type: TYPE_TAB,
        name: 'SETTING.str66',
        tab: 'devicelog'
    } 
    */
];

const MODBUS_TAB = [
  {
    type: TYPE_TAB,
    name: 'SETTING.queryList',
    tab: 'modbus',
  },
  {
    type: TYPE_TAB,
    name: 'SETTING.serial',
    tab: 'serial',
  },
  {
    type: TYPE_TAB,
    name: 'SETTING.queries',
    tab: 'query',
  },
];

const MODBUS_INFO_TEMPLATE = [
  {
    name: 'SETTING.mbusMode',
    type: TYPE_SEL,
    code: MENU_CODE.MBUS_MODE,
    list: [
      { value: 0, label: 'Modbus RTU' },
      { value: 1, label: 'Modbus ASCII' },
    ],
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.resTimeout',
    type: TYPE_INP,
    code: MENU_CODE.MBUS_TIMEOUT,
    form: FORMAT.INT,
    min: 200,
    max: 3000,
  },
  {
    name: 'SETTING.interframeGap',
    type: TYPE_INP,
    code: MENU_CODE.MBUS_IFGAP,
    form: FORMAT.INT,
    min: MIN_INTERFRAME_GAP,
    max: MAX_INTERFRAME_GAP,
  },
  {
    name: 'SETTING.baudRate',
    type: TYPE_SEL,
    code: MENU_CODE.BAUD_RATE,
    list: BAUD_RATE,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.parity',
    type: TYPE_SEL,
    code: MENU_CODE.PARITY,
    list: PARITY,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.dataBits',
    type: TYPE_SEL,
    code: MENU_CODE.DATA_BIT,
    list: DATA_BIT,
    form: FORMAT.INT,
  },
  {
    name: 'SETTING.stopBits',
    type: TYPE_SEL,
    code: MENU_CODE.STOP_BIT,
    list: STOP_BIT,
    form: FORMAT.INT,
  },
  {
    type: TYPE_SLV,
    code: MENU_CODE.MBUS_SLAVES,
    custom_class: 'single-row-item slave-row-item',
  },
];

const DEVICE_INFO_TEMPLATE_COMMON1 = [
  {
    name: 'SETTING.str50',
    type: TYPE_TXT,
    code: MENU_CODE.DEVMODEL,
  },
  {
    name: 'SETTING.str49',
    type: TYPE_TXT,
    code: MENU_CODE.DEVMACADDR,
  },
  {
    name: 'SETTING.str01',
    type: TYPE_INP,
    code: MENU_CODE.DEVDESC,
    max_len: MAX_STRING_LEN,
    form: FORMAT.STRING,
  },
  /*,
    {
        type: TYPE_SPR,
        name: 'SETTING.str66',
        code: MENU_CODE.SEPARATOR,
        custom_class: 'separator-row-item'
    },
    {
        name: 'SETTING.str76',
        type: TYPE_BTN,
        code: MENU_CODE.DEVREGLOG
    },
    {
        name: 'SETTING.str78',
        type: TYPE_BTN,
        code: MENU_CODE.DEVCONNLOG
    },
    {
        name: 'SETTING.str32',
        type: TYPE_BTN,
        code: MENU_CODE.DEVSETTLOG
    } 
    */
];
/*
var DEVICE_INFO_TEMPLATE_DIO = [
    {
        name: 'SETTING.str79',
        type: TYPE_BTN,
        code: MENU_CODE.DEVWEBLOG
    }
];

var DEVICE_INFO_TEMPLATE_DO = [
    {
        name: 'SETTING.str92',
        type: TYPE_BTN,
        log_only: true,
        code: MENU_CODE.DEVSCHLOG
    }
];

var DEVICE_INFO_TEMPLATE_COMMON2 = [
    {
        name: 'SETTING.str91',
        type: TYPE_BTN,
        log_only: true,
        code: MENU_CODE.DEVEVTLOG
    },
    {
        name: 'SETTING.str33',
        type: TYPE_LNK,
        code: MENU_CODE.GGLOG
    }
];
*/

/*
var DEVICE_LOG_TEMPLATE = [

];
*/

function createGeneralTab(isDI, isDO) {
  return GENERAL_INFO_TAB.concat(
    ...createTabData([GENERAL_INFO_TAB[0].tab], DEVICE_INFO_TEMPLATE_COMMON1)
  ); // .concat(...createTabData([GENERAL_INFO_TAB[1].tab], DEVICE_LOG_TEMPLATE))

  // return GENERAL_INFO_TAB.concat(...createTabData([GENERAL_INFO_TAB[0].tab], DEVICE_INFO_TEMPLATE_COMMON1.concat(isDI || isDO ? DEVICE_INFO_TEMPLATE_DIO : []).concat(isDO ? DEVICE_INFO_TEMPLATE_DO : []).concat(DEVICE_INFO_TEMPLATE_COMMON2)))// .concat(...createTabData([GENERAL_INFO_TAB[1].tab], DEVICE_LOG_TEMPLATE))
}

function createModbusTab() {
  return MODBUS_TAB.concat(
    ...createTabData([MODBUS_TAB[0].tab], MODBUS_INFO_TEMPLATE)
    // .concat(...createTabData([MODBUS_TAB[1].tab], SERIAL_INFO_TEMPLATE))
    // .concat(...createTabData([MODBUS_TAB[2].tab], SLAVE_INFO_TEMPLATE))
  ); // .concat(...createTabData([GENERAL_INFO_TAB[1].tab], DEVICE_LOG_TEMPLATE))

  // return GENERAL_INFO_TAB.concat(...createTabData([GENERAL_INFO_TAB[0].tab], DEVICE_INFO_TEMPLATE_COMMON1.concat(isDI || isDO ? DEVICE_INFO_TEMPLATE_DIO : []).concat(isDO ? DEVICE_INFO_TEMPLATE_DO : []).concat(DEVICE_INFO_TEMPLATE_COMMON2)))// .concat(...createTabData([GENERAL_INFO_TAB[1].tab], DEVICE_LOG_TEMPLATE))
}

function createThermoTab(numOfPorts) {
  const template = {
    type: TYPE_TAB,
  };
  const tabData = [];
  for (let i = 0; i < numOfPorts; i++) {
    tabData.push(template);
  }
  return tabData.map((t, index) => ({
    ...t,
    name: 'Ts' + index,
    tab: 'ts' + index,
  }));
}

function createAITab(numOfPorts) {
  const template = {
    type: TYPE_TAB,
  };
  const tabData = [];
  for (let i = 0; i < numOfPorts; i++) {
    tabData.push(template);
  }
  return tabData.map((t, index) => ({
    ...t,
    name: 'Ai' + index,
    tab: 'ai' + index,
  }));
}

function createDITab(numOfPorts) {
  const template = {
    type: TYPE_TAB,
  };
  const tabData = [];
  for (let i = 0; i < numOfPorts; i++) {
    tabData.push(template);
  }
  return tabData.map((t, index) => ({
    ...t,
    name: 'Di' + index,
    tab: 'di' + index,
  }));
}

function createDOTab(numOfPorts) {
  const template = {
    type: TYPE_TAB,
  };
  const tabData = [];
  for (let i = 0; i < numOfPorts; i++) {
    tabData.push(template);
  }
  return tabData.map((t, index) => ({
    ...t,
    name: 'Do' + index,
    tab: 'do' + index,
  }));
}

function createSIG5431Template() {
  const tabs = createAITab(4);
  const list = tabs.map((tab) => tab.tab);
  return createGeneralTab(false, false).concat(
    tabs.concat(...createAnalogInputPort(list))
  );
}

function createSIG5441Template() {
  const tabs = createDITab(4);
  const list = tabs.map((tab) => tab.tab);
  return createGeneralTab(true, false).concat(
    tabs.concat(...createDigitalInputPort(list))
  );
}

function createSIG5451Template() {
  const tabs = createDOTab(2);
  const list = tabs.map((tab) => tab.tab);
  return createGeneralTab(false, true).concat(
    tabs.concat(...createDigitalOutputPort(list))
  );
}

function createSIG5601Template() {
  const tabAI = createAITab(4);
  const tabDI = createDITab(4);
  const tabDO = createDOTab(4);
  const tabs = tabAI.concat(tabDI).concat(tabDO);
  const listAI = createAnalogInputPort(tabAI.map((tab) => tab.tab));
  const listDI = createDigitalInputPort(tabDI.map((tab) => tab.tab));
  const listDO = createDigitalOutputPort(tabDO.map((tab) => tab.tab));
  return createGeneralTab(true, true).concat(
    tabs
      .concat(...listAI)
      .concat(...listDI)
      .concat(...listDO)
  );
}

function createSMGTemplate() {
  return createGeneralTab(false, false).concat(createModbusTab());
}

function createSIGThermoTemplate() {
  const tabs = createThermoTab(1);
  const list = tabs.map((tab) => tab.tab);
  return createGeneralTab(false, true).concat(
    tabs.concat(...createAnalogThermoPort(list))
  );
}

function createTabData(numOfTabs, template) {
  const tabData = [];
  for (let i = 0; i < numOfTabs.length; i++) {
    tabData.push(template);
  }
  return tabData.map((t, index) =>
    t.map((item) => ({ ...item, parent: numOfTabs[index] }))
  );
  // return tabData.map((t, index) => t.map(item => ({...item, parent: numOfTabs[index], ...(item.code == 'port_desc' ? {value: numOfTabs[index]} : {})})));
}

function createAnalogInputPort(numOfTabs) {
  return createTabData(numOfTabs, ANALOG_INPUT_TEMPLATE);
}

function createDigitalInputPort(numOfTabs) {
  return createTabData(numOfTabs, DIGITAL_INPUT_TEMPLATE);
}

function createDigitalOutputPort(numOfTabs) {
  return createTabData(numOfTabs, DIGITAL_OUTPUT_TEMPLATE);
}

function createAnalogThermoPort(numOfTabs) {
  return createTabData(numOfTabs, ANALOG_THERMO_TEMPLATE);
}

export function getDeviceValue(template, vals = {}) {
  template.forEach((el) => {
    if (el.parent) {
      if (
        GENERAL_INFO_TAB.map((el) => el.tab).indexOf(el.parent) === -1 &&
        MODBUS_TAB.map((el) => el.tab).indexOf(el.parent) === -1
      ) {
        const portObject = vals.ports.find(
          (port) => port.port_name === el.parent
        );
        if (portObject == null) return;

        if (el.code != null) {
          if (portObject[el.code] instanceof Array) {
            el.value = portObject[el.code].slice(0);
          } else {
            el.value = portObject[el.code];
          }
        }
      } else {
        if (el.code != null) {
          el.value = vals[el.code];
        }
      }
    }
  });
  return template;
}

export function setDeviceValue(template, portsData) {
  template.forEach((el) => {
    if (el.parent) {
      if (
        GENERAL_INFO_TAB.map((el) => el.tab).indexOf(el.parent) === -1 &&
        MODBUS_TAB.map((el) => el.tab).indexOf(el.parent) === -1
      ) {
        const portObject = portsData.ports.find(
          (port) => port.port_name === el.parent
        );
        portObject[el.code] = el.value;
      } else {
        portsData[el.code] = el.value;
      }
    }
  });
  return portsData;
}

function getScheduleSetting(settings, referenceSetting) {
  return settings
    .filter((schedule) => {
      switch (schedule.action) {
        case STS.ADD:
        case STS.DELETE:
          return true;
        case STS.UPDATE:
          const ref = referenceSetting.find(
            (s) => s.schedule_id === schedule.schedule_id
          );
          return (
            ref &&
            (ref.repeated !== schedule.repeated ||
              JSON.stringify(ref.time_dayofweek.sort()) !==
                JSON.stringify(schedule.time_dayofweek.sort()) ||
              ref.time_hours !== schedule.time_hours ||
              ref.time_minutes !== schedule.time_minutes ||
              getBoolean(ref.schedule_enabled) !==
                getBoolean(schedule.schedule_enabled) ||
              ref.command !== schedule.command ||
              JSON.stringify(ref.event_action.sort()) !==
                JSON.stringify(schedule.event_action.sort()))
          );
      }
    })
    .map((sch) => {
      if (sch.action === STS.ADD) {
        return {
          action: sch.action,
          repeated: sch.repeated,
          time_dayofweek: sch.time_dayofweek,
          time_hours: sch.time_hours,
          time_minutes: sch.time_minutes,
          command: sch.command,
          event_action: sch.event_action,
        };
      } else if (sch.action === STS.DELETE) {
        return {
          action: sch.action,
          schedule_id: sch.schedule_id,
        };
      } else if (sch.action === STS.UPDATE) {
        return {
          action: sch.action,
          schedule_id: sch.schedule_id,
          repeated: sch.repeated,
          time_dayofweek: sch.time_dayofweek,
          time_hours: sch.time_hours,
          time_minutes: sch.time_minutes,
          command: sch.command,
          event_action: sch.event_action,
          schedule_enabled: getBoolean(sch.schedule_enabled),
        };
      }
    });
}

function getSlaveSetting(settings, referenceSetting) {
  return settings
    .filter((slave) => {
      switch (slave.action) {
        case STS.ADD:
        case STS.DELETE:
          return true;
        case STS.UPDATE:
          const ref = referenceSetting.find((s) => s.port_id === slave.port_id);
          return (
            ref &&
            (ref.slave_addr !== slave.slave_addr ||
              (ref.query_type === 'MB' &&
                (ref.req_func !== slave.req_func ||
                  ref.req_addr !== slave.req_addr)) ||
              (ref.query_type === 'HMI' && ref.hmi_addr !== slave.hmi_addr) ||
              ref.rep_offset !== slave.rep_offset ||
              ref.rep_scale !== slave.rep_scale ||
              ref.slave_desc !== slave.slave_desc ||
              ref.dec_place !== slave.dec_place ||
              ref.data_type !== slave.data_type ||
              ref.byte_swap !== slave.byte_swap ||
              ref.word_swap !== slave.word_swap ||
              ref.dword_swap !== slave.dword_swap ||
              ref.port_offset !== slave.port_offset ||
              ref.port_quantity !== slave.port_quantity ||
              // ref.req_data !== slave.req_data ||
              getBoolean(ref.slave_enabled) !==
                getBoolean(slave.slave_enabled) ||
              (typeof ref.widget === 'string'
                ? ref.widget
                : JSON.stringify(ref.widget)) !==
                (typeof slave.widget === 'string'
                  ? slave.widget
                  : JSON.stringify(slave.widget)))
          );
      }
    })
    .map((slv) => {
      if (slv.action === STS.ADD) {
        return {
          action: slv.action,
          slave_desc: slv.slave_desc,
          slave_addr: slv.slave_addr,
          rep_offset: slv.rep_offset,
          rep_scale: slv.rep_scale,
          query_type: slv.query_type,
          ...(slv.query_type === 'MB'
            ? {
                req_func: slv.req_func,
                req_addr: slv.req_addr,
              }
            : {
                hmi_addr: slv.hmi_addr,
              }),
          byte_swap: slv.byte_swap,
          word_swap: slv.word_swap,
          dword_swap: slv.dword_swap,
          port_offset: slv.port_offset,
          port_quantity: slv.port_quantity,
          data_type: slv.data_type,
          dec_place: slv.dec_place,
          // req_data: slv.req_data,
          widget:
            typeof slv.widget === 'string'
              ? slv.widget
              : JSON.stringify(slv.widget),
        };
      } else if (slv.action === STS.DELETE) {
        return {
          action: slv.action,
          port_id: slv.port_id,
          query_type: slv.query_type,
        };
      } else if (slv.action === STS.UPDATE) {
        const ref = referenceSetting.find((s) => s.port_id === slv.port_id);

        return {
          action: slv.action,
          port_id: slv.port_id,
          query_type: slv.query_type,
          slave_desc: slv.slave_desc,
          slave_addr: slv.slave_addr,
          rep_offset: slv.rep_offset,
          rep_scale: slv.rep_scale,
          dec_place: slv.dec_place,
          events: getEventSetting(slv.events, true, ref.events),

          ...(slv.query_type === 'MB'
            ? {
                req_func: slv.req_func,
                req_addr: slv.req_addr,
              }
            : {
                hmi_addr: slv.hmi_addr,
              }),
          byte_swap: slv.byte_swap,
          word_swap: slv.word_swap,
          dword_swap: slv.dword_swap,
          port_offset: slv.port_offset,
          port_quantity: slv.port_quantity,
          data_type: slv.data_type,
          // req_data: slv.req_data,
          widget:
            typeof slv.widget === 'string'
              ? slv.widget
              : JSON.stringify(slv.widget),
          slave_enabled: getBoolean(slv.slave_enabled),
        };
      }
    });
}

function getActionSetting(actionList, referenceSetting) {
  return actionList
    .filter((action) => {
      switch (action.action) {
        case STS.ADD:
        case STS.DELETE:
          return true;
        case STS.UPDATE:
          const ref =
            referenceSetting &&
            referenceSetting.ctrl_actions &&
            referenceSetting.ctrl_actions.find(
              (a) => a.ctrl_action_id === action.ctrl_action_id
            );
          return (
            ref &&
            (ref.port_id !== action.port_id || ref.command !== action.command)
          );
      }
    })
    .map((evt) => {
      if (evt.action === STS.ADD) {
        if (!referenceSetting) {
          return {
            port_id: evt.port_id,
            command: evt.command,
          };
        } else {
          return {
            action: evt.action,
            port_id: evt.port_id,
            command: evt.command,
          };
        }
      } else if (evt.action === STS.DELETE) {
        return {
          action: evt.action,
          ctrl_action_id: evt.ctrl_action_id,
        };
      } else if (evt.action === STS.UPDATE) {
        return {
          action: evt.action,
          port_id: evt.port_id,
          command: evt.command,
          ctrl_action_id: evt.ctrl_action_id,
        };
      }
    });
}

function getEventSetting(settings, isAnalog, referenceSetting) {
  return settings
    .filter((event) => {
      switch (event.action) {
        case STS.ADD:
        case STS.DELETE:
          return true;
        case STS.UPDATE:
          const ref = referenceSetting.find(
            (e) => e.event_id === event.event_id
          );
          return (
            ref &&
            (ref.event_condition !== event.event_condition ||
              ref.event_desc !== event.event_desc ||
              ref.event_value !== event.event_value ||
              ref.event_noise !== event.event_noise ||
              getBoolean(ref.event_enabled) !==
                getBoolean(event.event_enabled) ||
              JSON.stringify(ref.event_action.sort()) !==
                JSON.stringify(event.event_action.sort()) ||
              getActionSetting(event.ctrl_actions, ref).length)
          );
      }
    })
    .map((evt) => {
      if (evt.action === STS.ADD) {
        return Object.assign(
          {
            action: evt.action,
            event_condition: evt.event_condition,
            event_desc: evt.event_desc, // encodeURI(evt.event_desc),
            event_value: Number(evt.event_value),
            event_action: evt.event_action,
            json_keys: evt.json_keys,
            ctrl_actions: getActionSetting(evt.ctrl_actions),
          },
          isAnalog && { event_noise: Number(evt.event_noise) }
        );
      } else if (evt.action === STS.DELETE) {
        return {
          action: evt.action,
          event_id: evt.event_id,
        };
      } else if (evt.action === STS.UPDATE) {
        const refer = referenceSetting.find((e) => e.event_id === evt.event_id);
        return Object.assign(
          {
            action: evt.action,
            event_condition: evt.event_condition,
            event_desc: evt.event_desc, // encodeURI(evt.event_desc),
            event_value: Number(evt.event_value),
            event_id: evt.event_id,
            event_enabled: getBoolean(evt.event_enabled),
            event_action: evt.event_action,
            json_keys: evt.json_keys,
            ctrl_actions: getActionSetting(evt.ctrl_actions, refer),
          },
          isAnalog && { event_noise: Number(evt.event_noise) }
        );
      }
    });
}

export function getSettingList(data, savedData, fullData) {
  const res = [];

  const tobeSaved = cloneObject(data);
  if (JSON.stringify(tobeSaved) === savedData) {
    return res;
  }
  const saved = JSON.parse(savedData);
  const original = cloneObject(fullData);

  if (isModbusGateway(original.dev_model)) {
    if (tobeSaved.ports) {
      tobeSaved.ports.forEach((slv) => {
        const { events, query_type } = slv;
        const urlPath = query_type === 'MB' ? 'modbus-slaves' : 'hmis';
        if (events && events.length) {
          events.forEach((evt) => {
            const {
              event_condition,
              event_value,
              event_noise,
              event_desc,
              event_action,
              ctrl_actions,
              event_enabled,
            } = evt;
            switch (evt.action) {
              case STS.ADD:
                res.push({
                  relative_url: `v3/users/me/${urlPath}/${slv.port_id}/events`,
                  method: 'POST',
                  body: {
                    event_condition,
                    event_value,
                    ...(event_noise != null && { event_noise: event_noise }),
                    event_desc,
                    event_action,
                    ctrl_actions,
                  },
                });
                break;
              case STS.UPDATE:
                ctrl_actions.forEach((ctrl_action) => {
                  const { port_id, command, ctrl_action_id } = ctrl_action;
                  switch (ctrl_action.action) {
                    case STS.ADD:
                      res.push({
                        relative_url: `v3/users/me/events/${evt.event_id}/ctrl-actions`,
                        method: 'POST',
                        body: {
                          port_id,
                          command,
                        },
                      });
                      break;
                    case STS.UPDATE:
                      res.push({
                        relative_url: `v3/users/me/ctrl-actions/${ctrl_action_id}`,
                        method: 'PUT',
                        body: {
                          port_id,
                          command,
                        },
                      });
                      break;
                    case STS.DELETE:
                      res.push({
                        relative_url: `v3/users/me/ctrl-actions/${ctrl_action_id}`,
                        method: 'DELETE',
                        body: '',
                      });
                      break;
                  }
                });
                const originalPort = original.ports.find(
                  (p) => p.port_id === slv.port_id
                );
                const originalEvt = originalPort.events.find(
                  (ev) => ev.event_id === evt.event_id
                );
                for (const prop in evt) {
                  if (
                    Object.prototype.hasOwnProperty.call(evt, prop) &&
                    ['ctrl_actions', 'action'].indexOf(prop) === -1
                  ) {
                    if (
                      JSON.stringify(evt[prop]) !==
                      JSON.stringify(originalEvt[prop])
                    ) {
                      res.push({
                        relative_url: `v3/users/me/events/${urlPath}/${evt.event_id}`,
                        method: 'PUT',
                        body: {
                          event_condition,
                          event_value,
                          ...(event_noise != null && {
                            event_noise: event_noise,
                          }),
                          event_desc,
                          event_action,
                          event_enabled,
                        },
                      });
                      break;
                    }
                  }
                }

                break;
              case STS.DELETE:
                res.push({
                  relative_url: `v3/users/me/events/${evt.event_id}`,
                  method: 'DELETE',
                  body: '',
                });
                break;
            }
          });
        }
      });
    }
    if (tobeSaved.mb_ports) {
      if (tobeSaved.mb_ports.length) {
        tobeSaved.mb_ports.forEach((slv) => {
          const {
            slave_addr,
            slave_desc,
            slave_enabled,
            req_func,
            req_addr,
            hmi_addr,
            rep_offset,
            rep_scale,
            byte_swap,
            word_swap,
            dword_swap,
            port_offset,
            port_quantity,
            data_type,
            dec_place,
            // req_data,
            widget,
            query_type,
          } = slv;
          const urlPath = query_type === 'MB' ? 'modbus-slaves' : 'hmis';

          switch (slv.action) {
            case STS.ADD:
              res.push({
                relative_url: `v3/users/me/devices/${original.dev_id}/${urlPath}`,
                method: 'POST',
                body: {
                  slave_addr,
                  slave_desc,
                  ...(query_type === 'MB'
                    ? { req_func, req_addr }
                    : { hmi_addr }),
                  rep_offset,
                  rep_scale,
                  byte_swap,
                  word_swap,
                  dword_swap,
                  port_offset,
                  port_quantity,
                  data_type,
                  dec_place,
                  // req_data,
                  widget,
                },
              });
              break;
            case STS.UPDATE:
              res.push({
                relative_url: `v3/users/me/${urlPath}/${slv.port_id}`,
                method: 'PUT',
                body: {
                  slave_addr,
                  slave_desc,
                  slave_enabled,
                  ...(query_type === 'MB'
                    ? { req_func, req_addr }
                    : { hmi_addr }),
                  rep_offset,
                  rep_scale,
                  byte_swap,
                  word_swap,
                  dword_swap,
                  port_offset,
                  port_quantity,
                  data_type,
                  dec_place,
                  // req_data,
                  widget,
                },
              });
              break;
            case STS.DELETE:
              res.push({
                relative_url: `v3/users/me/${urlPath}/${slv.port_id}`,
                method: 'DELETE',
                body: '',
              });
              break;
          }
        });
      }
    }
  } else {
    if (tobeSaved.ports) {
      tobeSaved.ports.forEach((port) => {
        const originalPort = original.ports.find(
          (p) => p.port_id === port.port_id
        );
        if (port.events.length) {
          port.events.forEach((evt) => {
            const {
              event_condition,
              event_value,
              event_noise,
              event_desc,
              event_action,
              ctrl_actions,
              event_enabled,
              json_keys,
            } = evt;
            switch (evt.action) {
              case STS.ADD:
                res.push({
                  relative_url: `v3/users/me/ports/${port.port_type.toLowerCase()}/${
                    port.port_id
                  }/events`,
                  method: 'POST',
                  body: {
                    event_condition,
                    event_value,
                    ...(event_noise != null && { event_noise: event_noise }),
                    event_desc,
                    event_action,
                    ctrl_actions,
                    json_keys,
                  },
                });
                break;
              case STS.UPDATE:
                ctrl_actions.forEach((ctrl_action) => {
                  const { port_id, command, ctrl_action_id } = ctrl_action;
                  switch (ctrl_action.action) {
                    case STS.ADD:
                      res.push({
                        relative_url: `v3/users/me/events/${evt.event_id}/ctrl-actions`,
                        method: 'POST',
                        body: {
                          port_id,
                          command,
                        },
                      });
                      break;
                    case STS.UPDATE:
                      res.push({
                        relative_url: `v3/users/me/ctrl-actions/${ctrl_action_id}`,
                        method: 'PUT',
                        body: {
                          port_id,
                          command,
                        },
                      });
                      break;
                    case STS.DELETE:
                      res.push({
                        relative_url: `v3/users/me/ctrl-actions/${ctrl_action_id}`,
                        method: 'DELETE',
                        body: '',
                      });
                      break;
                  }
                });
                const originalEvt = originalPort.events.find(
                  (ev) => ev.event_id === evt.event_id
                );
                for (const prop in evt) {
                  if (
                    Object.prototype.hasOwnProperty.call(evt, prop) &&
                    ['ctrl_actions', 'action'].indexOf(prop) === -1
                  ) {
                    if (
                      JSON.stringify(evt[prop]) !==
                      JSON.stringify(originalEvt[prop])
                    ) {
                      res.push({
                        relative_url: `v3/users/me/events/${originalPort.port_type.toLowerCase()}/${
                          evt.event_id
                        }`,
                        method: 'PUT',
                        body: {
                          event_condition,
                          event_value,
                          ...(event_noise != null && {
                            event_noise: event_noise,
                          }),
                          event_desc,
                          event_action,
                          event_enabled,
                          json_keys,
                        },
                      });
                      break;
                    }
                  }
                }
                break;
              case STS.DELETE:
                res.push({
                  relative_url: `v3/users/me/events/${evt.event_id}`,
                  method: 'DELETE',
                  body: '',
                });
                break;
            }
          });
        }

        if (port.schedules && port.schedules.length) {
          port.schedules.forEach((sch) => {
            const {
              time_dayofweek,
              time_hours,
              time_minutes,
              repeated,
              command,
              event_action,
              schedule_enabled,
            } = sch;
            switch (sch.action) {
              case STS.ADD:
                res.push({
                  relative_url: `v3/users/me/ports/${port.port_type.toLowerCase()}/${
                    port.port_id
                  }/schedules`,
                  method: 'POST',
                  body: {
                    time_dayofweek,
                    time_hours,
                    time_minutes,
                    repeated,
                    command,
                    event_action,
                  },
                });
                break;
              case STS.UPDATE:
                const originalSch = originalPort.schedules.find(
                  (sc) => sc.schedule_id === sch.schedule_id
                );
                for (const prop in sch) {
                  if (
                    Object.prototype.hasOwnProperty.call(sch, prop) &&
                    ['action'].indexOf(prop) === -1
                  ) {
                    if (
                      JSON.stringify(sch[prop]) !==
                      JSON.stringify(originalSch[prop])
                    ) {
                      res.push({
                        relative_url: `v3/users/me/schedules/${sch.schedule_id}`,
                        method: 'PUT',
                        body: {
                          time_dayofweek,
                          time_hours,
                          time_minutes,
                          repeated,
                          command,
                          event_action,
                          schedule_enabled,
                        },
                      });
                      break;
                    }
                  }
                }
                break;
              case STS.DELETE:
                res.push({
                  relative_url: `v3/users/me/schedules/${sch.schedule_id}`,
                  method: 'DELETE',
                  body: '',
                });
                break;
            }
          });
        }

        delete port.events;
        delete port.schedules;
        const url = `v3/users/me/ports/${port.port_type.toLowerCase()}/${
          port.port_id
        }`;
        delete port.port_type;
        delete port.port_id;
        for (const prop in port) {
          if (Object.prototype.hasOwnProperty.call(port, prop)) {
            if (
              JSON.stringify(port[prop]) !== JSON.stringify(originalPort[prop])
            ) {
              res.push({
                relative_url: url,
                method: 'PUT',
                body: port,
              });
              break;
            }
          }
        }
      });
    }
  }

  delete tobeSaved.ports;
  delete tobeSaved.mb_ports;
  delete tobeSaved.dev_client_id;
  for (const prop in tobeSaved) {
    if (Object.prototype.hasOwnProperty.call(tobeSaved, prop)) {
      if (JSON.stringify(tobeSaved[prop]) !== JSON.stringify(saved[prop])) {
        res.push({
          relative_url: `v3/users/me/devices/${original.dev_model.toLowerCase()}/${
            original.dev_id
          }`,
          method: 'PUT',
          body: tobeSaved,
        });
        break;
      }
    }
  }
  return res;
}

export function getModifiedSetting(pData, reference) {
  const portData = Object.freeze(cloneObject(pData));
  const deviceSetting = {};
  portData.ports
    .filter((el) => el.port_type === DIGITAL_INPUT)
    .forEach((port) => {
      deviceSetting[(port.port_name + '').toUpperCase()] = {
        count_def: port.count_def,
        count_dir: port.count_dir,
        count_type: port.count_type,
        valid_time: port.valid_time,
      };
    });
  if (isModbusGateway(portData.dev_model)) {
    return {
      CLOUD: {
        dev_desc: portData.dev_desc,
        modbus_mode: portData.modbus_mode,
        modbus_timeout: portData.modbus_timeout,
        modbus_interframe_gap: portData.modbus_interframe_gap,
        serial_baudrate: portData.serial_baudrate,
        serial_parity: portData.serial_parity,
        serial_data_bit: portData.serial_data_bit,
        serial_stop_bit: portData.serial_stop_bit,
        mb_ports: getSlaveSetting(portData.ports, reference.ports),
        ports: portData.ports
          .filter(
            (port) => port.action !== STS.ADD && port.action !== STS.DELETE
          )
          .map((port) => {
            const refPort = reference.ports.find(
              (p) => p.port_id === port.port_id
            );
            return {
              port_id: port.port_id,
              query_type: port.query_type,
              events: getEventSetting(port.events, true, refPort.events),
            };
          }),
      },
    };
  }
  return {
    CLOUD: {
      dev_client_id: portData.dev_client_id,
      dev_desc: portData.dev_desc, // encodeURI(port.port_desc),

      ports: portData.ports.map((port) => {
        const refPort = reference.ports.find((p) => p.port_id === port.port_id);
        switch (port.port_type) {
          case TEMPERATURE:
            return {
              port_id: port.port_id,
              port_type: port.port_type,
              port_desc: port.port_desc,
              ui_display: port.ui_display,
              ui_widget: port.ui_widget,
              ui_color: port.ui_color,
              // dec_place: port.dec_place,
              display_min: port.display_min,
              display_max: port.display_max,
              events: getEventSetting(port.events, true, refPort.events),
            };
          case ANALOG_INPUT:
            return {
              port_id: port.port_id,
              port_type: port.port_type,
              port_desc: port.port_desc, // encodeURI(port.port_desc),
              ui_display: port.ui_display,
              ui_widget: port.ui_widget,
              ui_color: port.ui_color,
              port_min: port.port_min,
              port_max: port.port_max,
              dec_place: port.dec_place,
              unit: port.unit,
              display_min: port.display_min,
              display_max: port.display_max,
              events: getEventSetting(port.events, true, refPort.events),
            };
          case DIGITAL_INPUT:
            return {
              port_id: port.port_id,
              port_type: port.port_type,
              port_desc: port.port_desc, // encodeURI(port.port_desc),
              ui_display: port.ui_display,
              ui_widget: port.ui_widget,
              ui_color: port.ui_color,
              events: getEventSetting(port.events, false, refPort.events),
            };
          case DIGITAL_OUTPUT:
            return {
              port_id: port.port_id,
              port_type: port.port_type,
              port_desc: port.port_desc, // encodeURI(port.port_desc),
              ui_display: port.ui_display,
              ui_widget: port.ui_widget,
              ui_color: port.ui_color,
              relay_mode: port.relay_mode,
              commands: port.commands,
              events: getEventSetting(port.events, false, refPort.events),
              schedules: getScheduleSetting(port.schedules, refPort.schedules),
            };
        }
      }),
    },
    DEVICE: deviceSetting,
  };
}

export function createDeviceSettingData(model) {
  switch (model) {
    case SOLLAE_MODEL.SIG_5431:
      return createSIG5431Template();
    case SOLLAE_MODEL.SIG_5441:
      return createSIG5441Template();
    case SOLLAE_MODEL.SIG_5451:
      return createSIG5451Template();
    case SOLLAE_MODEL.SIG_5601:
      return createSIG5601Template();
    case SOLLAE_MODEL.SIG_5561:
      return createSIGThermoTemplate();
    case SOLLAE_MODEL.SMG_5511:
    case SOLLAE_MODEL.SMG_5521:
      return createSMGTemplate();
  }
}
